import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../../apimethods/api-method';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
import { IssueElementAPIModel } from './issue-elements';
declare var $;

@Component({
  selector: 'app-issue-elements',
  templateUrl: './issue-elements.component.html',
  styleUrls: ['./issue-elements.component.css']
})

/** IssueElements component*/
export class IssueElementsComponent implements OnInit {
  modelItem = new IssueElementAPIModel();
  @ViewChild('dataTable', { static: false }) table: { nativeElement: any; }
  dataSet: string;
  dataTable: any;
  showModal: boolean;
  popUpButtonText: string;
  title: string;
  publisher: any;
    GetGroupName: any;
  /** IssueElements ctor */
  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }
  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <IssueElementAPIModel>data["IssueElementsPage"];
        this.MainGridTable();
        this.GetPublisherID();
        this.GetElements();


        $('#ddlElements').select2({
          placeholder: "Select Elements",
           allowClear: true, tags: true,
          dropdownParent: "#popupbody"

        });

        $('#ddlSelectionMode').select2({
          placeholder: "Select Selection Mode",
          allowClear: true, tags: true,
          dropdownParent: "#popupbody"
        });

        $('#ddlGroupName').select2({
          placeholder: "Select Group Name",
          allowClear: true, tags: true,
          dropdownParent: "#popupbody"
        });
       
        //publisher list
        $('#ddlPublisher').select2({
          placeholder: "Select Publisher",
          allowClear: true, tags: true,
          dropdownParent: "#popupbody"
        });
        $('#ddlPublisher').val([]).trigger('change');

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });

  }
  //Get PublisherId
  GetPublisherID(): void {

    ApiMethod.getMethod(this.modelItem.issueElementPubIDAPI).subscribe(
      result => {
        this.publisher = result.aPublisher;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
   //GetElements and GroupName
  GetElements(): void {

    ApiMethod.getMethod(this.modelItem.GetGroupByElements).subscribe(
      result => {
        this.GetElements = result.aElements;
        this.GetGroupName = result.aGroupName;
     
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }

  //IssueElement MainTable 
  MainGridTable() {
    $("LoadingImage").show();

    var dataparam = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      ModuleName: "IssueElementsModule"
    }


    ApiMethod.postMethod(this.modelItem.IssueElementTableGridAPI, dataparam).subscribe(
      Response => {
        this.dataSet = JSON.stringify(Response.aIssueElementdata); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = Response.gridColumnList; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'IssueElementsModule';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  
  GetIssueElementById() {
    $("LoadingImagePopup").show();
    this.ClearData();
    $('#btnPopupartDetails').show();


    if (localStorage.aEID != 0) {
      ApiMethod.getMethod(this.modelItem.GetIssueElementByIdAPI + "/" + localStorage.aEID).subscribe(
        Response => {
          var aitems = Response.item;
          console.log(Response.item);


          $('#ddlElements').val(aitems[0].Elements).change();
          $('#ddlGroupName').val(aitems[0].GroupName).change();
          $('#ddlSelectionMode').val(aitems[0].SelectionMode).change();
          $('#Txt_Pages').val(aitems[0].Pages);
          $('#Txt_FileType').val(aitems[0].FileType);
          $('#Txt_FileFormat').val(aitems[0].FileFormat);
          if (aitems[0].IsMandatory == 1) {
            $('#Txt_IsMandatory').prop('checked', true);
          } else {
            $('#Txt_IsMandatory').prop('checked', false);
          }


          this.title = " Issue Elements : " + aitems[0].Elements + " ";
          this.popUpButtonText = "Update";
          $("LoadingImagePopup").hide();
        },
        error => {
          $("#LoadingImagePopup").hide();
          ngswal("Failed !", error.message, "error");
        });
    } else {
      //show popup
      $('#btnPopupartDetails').show();

      //Title and button Values
      this.popUpButtonText = "Add";
      this.title = " Add Issue Elements ";
      localStorage.aEID = "";
      $("LoadingImagePopup").hide();
    }
  }

  UpdateTemplate(): void {

    //Validation 
    if ($('#ddlElements').val() == null) {
      ngswal("Warning !", "Select Elements !", "warning");
    }
    else if ($('#ddlGroupName').val() == null) {
      ngswal("Warning !", "Select GroupName!", "warning");
    }
    else if ($('#ddlSelectionMode').val() == null) {
      ngswal("Warning !", "Select SelectionMode!", "warning");
    }
    else if ($('#Txt_Pages').val().trim() == '') {
      ngswal("Warning !", "Enter Pages!", "warning");
    }
    else if ($('#Txt_FileType').val().trim() == '') {
      ngswal("Warning !", "Enter FileType!", "warning");
    }
    else if ($('#Txt_FileFormat').val().trim() == '') {
      ngswal("Warning !", "Enter FileName!", "warning");
    }
    else {
      //Getting Updated value
      $("#LoadingImagePopup").hide();
      var ismandatory = $('#Txt_IsMandatory').prop('checked');
      if (ismandatory == true) {
        ismandatory = 1;
      } else {
        ismandatory = 0;
      }
      var dataparam = {

        ID: localStorage.aEID,
        PublisherID: localStorage.aPubID,
        Elements: $('#ddlElements').val(),
        GroupName: $('#ddlGroupName').val(),
        SelectionMode: $('#ddlSelectionMode').val(),
        Pages: $('#Txt_Pages').val(),
        FileType: $('#Txt_FileType').val(),
        FileFormat: $('#Txt_FileFormat').val(),
        IsMandatory: ismandatory,

      };

      ApiMethod.postMethod(this.modelItem.AddUpdateIssueElementAPI, dataparam).subscribe(
        response => {
          this.MainGridTable();
          $("#LoadingImagePopup").hide();
          this.hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response.addEditIssueElement,
            showConfirmButton: true,

          });

        },
        error => {
          ngswal("Failed !", error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  hide() {
    this.ClearData();
    $('#btnPopupartDetails').hide();
  }

  ClearData(): void {
    $('#ddlElements').val(0).change();
    $('#ddlGroupName').val(0).change();
    $('#ddlSelectionMode').val(0).change();
    $('#Txt_Pages').val('');
    $('#Txt_FileType').val('');
    $('#Txt_FileFormat').val('');
    $('#Txt_IsMandatory').prop('checked', false);
    $("#ddlPublisher").val(0).change();

  }

}


